var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("loading", {
        attrs: { active: _vm.isLoading, loader: "dots" },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c("div", { staticClass: "card search-card" }, [
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "form-row" }, [
            _c("div", { staticClass: "col-sm-3 col-md-3" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "" } }, [_vm._v("面談日期")]),
                  _c(
                    "el-date-picker",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        "value-format": "yyyy-MM-dd",
                        type: "daterange",
                        "start-placeholder": "開始日期",
                        "end-placeholder": "結束日期",
                      },
                      model: {
                        value: _vm.search.RangeDate,
                        callback: function ($$v) {
                          _vm.$set(_vm.search, "RangeDate", $$v)
                        },
                        expression: "search.RangeDate",
                      },
                    },
                    [_vm._v(" > ")]
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "col-sm-3 col-md-3" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "" } }, [_vm._v("時段")]),
                  _c(
                    "el-select",
                    {
                      staticStyle: { display: "block" },
                      attrs: {
                        placeholder: "請選擇",
                        filterable: "",
                        clearable: "",
                      },
                      model: {
                        value: _vm.search.TimePeriod,
                        callback: function ($$v) {
                          _vm.$set(_vm.search, "TimePeriod", $$v)
                        },
                        expression: "search.TimePeriod",
                      },
                    },
                    _vm._l(_vm.timePeriodOptions, function (option) {
                      return _c("el-option", {
                        key: option.Value,
                        attrs: { label: option.Text, value: option.Value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "col-sm-3 col-md-3" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "search-name" } }, [
                    _vm._v("報到情形"),
                  ]),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        multiple: "",
                        filterable: "",
                        clearable: "",
                        placeholder: "請選擇",
                      },
                      model: {
                        value: _vm.search.CheckInStatus,
                        callback: function ($$v) {
                          _vm.$set(_vm.search, "CheckInStatus", $$v)
                        },
                        expression: "search.CheckInStatus",
                      },
                    },
                    _vm._l(_vm.checkInStatusOptions, function (item) {
                      return _c("el-option", {
                        key: item.Value,
                        attrs: { label: item.Text, value: item.Value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "col-sm-3 col-md-3" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "search-name" } }, [
                    _vm._v("應徵職務"),
                  ]),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        filterable: "",
                        clearable: "",
                        placeholder: "請選擇",
                      },
                      model: {
                        value: _vm.search.ManpowerDemandNo,
                        callback: function ($$v) {
                          _vm.$set(_vm.search, "ManpowerDemandNo", $$v)
                        },
                        expression: "search.ManpowerDemandNo",
                      },
                    },
                    _vm._l(_vm.positionOptions, function (item) {
                      return _c("el-option", {
                        key: item.Value,
                        attrs: { label: item.Text, value: item.Value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "col-sm-3 col-md-3" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "search-name" } }, [
                    _vm._v("招募窗口"),
                  ]),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        filterable: "",
                        clearable: "",
                        "collapse-tags": "",
                        multiple: "",
                        placeholder: "請選擇窗口",
                      },
                      model: {
                        value: _vm.search.ContactPersonGuid,
                        callback: function ($$v) {
                          _vm.$set(_vm.search, "ContactPersonGuid", $$v)
                        },
                        expression: "search.ContactPersonGuid",
                      },
                    },
                    _vm._l(_vm.contactOptions, function (item) {
                      return _c("el-option", {
                        key: item.Value,
                        attrs: { label: item.Text, value: item.Value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "col-sm-3 col-md-3" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "" } }, [_vm._v("面試狀態")]),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        filterable: "",
                        clearable: "",
                        placeholder: "請選擇",
                      },
                      model: {
                        value: _vm.search.InterviewStatus,
                        callback: function ($$v) {
                          _vm.$set(_vm.search, "InterviewStatus", $$v)
                        },
                        expression: "search.InterviewStatus",
                      },
                    },
                    _vm._l(_vm.interviewStatusOptions, function (item) {
                      return _c("el-option", {
                        key: item.Value,
                        attrs: { label: item.Text, value: item.Value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "col-sm-3 col-md-3" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "search-name" } }, [
                  _vm._v("姓名"),
                ]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.search.NameKeyword,
                      expression: "search.NameKeyword",
                      modifiers: { trim: true },
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    type: "text",
                    id: "search-name",
                    placeholder: "請輸入關鍵字",
                  },
                  domProps: { value: _vm.search.NameKeyword },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.search,
                        "NameKeyword",
                        $event.target.value.trim()
                      )
                    },
                    blur: function ($event) {
                      return _vm.$forceUpdate()
                    },
                  },
                }),
              ]),
            ]),
            _c("div", { staticClass: "col-sm-3 col-md-3" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  staticStyle: { "margin-top": "30px", "margin-right": "5px" },
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.getFlowOverview()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Search")) + " ")]
              ),
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  staticStyle: { "margin-top": "30px", "margin-right": "5px" },
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      _vm.search = {
                        RangeDate: _vm.search.RangeDate,
                      }
                    },
                  },
                },
                [_vm._v(" 清除 ")]
              ),
            ]),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "text-right" }, [
        _vm._v(" 更新時間:" + _vm._s(_vm.reloadTime) + " "),
      ]),
      _c(
        "div",
        { staticClass: "fixed-list-item" },
        [
          _c("eva-icon", {
            attrs: { fill: "#000", name: "refresh-outline" },
            on: { click: _vm.reload },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "text-right" }, [
        _c("span", { staticStyle: { position: "relative", bottom: "-30px" } }, [
          _vm._v("共計" + _vm._s(_vm.rows.length) + "人"),
        ]),
      ]),
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.getFlowOverview },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c("el-tab-pane", { attrs: { label: "全部", name: "All" } }),
          _c("el-tab-pane", { attrs: { label: "IDL", name: "IDL" } }),
          _c("el-tab-pane", { attrs: { label: "DL", name: "DL" } }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "yahome-table-wrap" },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.rows,
                height: "400px",
                "default-sort": { prop: "CheckInType", order: "descending" },
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "類型",
                  fixed: "left",
                  sortable: "",
                  "sort-method": (a, b) => _vm.defaultSort(a, b, "CheckInType"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        props.row.CheckInType === 1
                          ? _c("span", [_vm._v("預約到廠")])
                          : _vm._e(),
                        props.row.CheckInType === 2
                          ? _c("span", [_vm._v("臨時到廠")])
                          : _vm._e(),
                        _c("span"),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "Name",
                  label: "應徵者姓名",
                  width: "180",
                  fixed: "left",
                  sortable: "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c(
                          "span",
                          {
                            staticClass: "name-link",
                            class: {
                              female: props.row.Sex === "女",
                              male: props.row.Sex === "男",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.showDetailModal(props.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(props.row.Name))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "MobilePhone",
                  label: "手機號碼",
                  width: "120",
                  fixed: "left",
                  sortable: "",
                  "sort-method": (a, b) => _vm.defaultSort(a, b, "MobilePhone"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "IdNo",
                  label: "身分證字號",
                  width: "120",
                  fixed: "left",
                  sortable: "",
                  "sort-method": (a, b) => _vm.defaultSort(a, b, "IdNo"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "Sex",
                  label: "性別",
                  sortable: "",
                  "sort-method": (a, b) => _vm.defaultSort(a, b, "Sex"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "ManpowerDemandName",
                  label: "應徵職務",
                  width: "120",
                  sortable: "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "報到情形",
                  width: "120",
                  sortable: "",
                  "sort-method": (a, b) => _vm.defaultSort(a, b, "Status"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        props.row.Status === 1
                          ? _c("span", [_vm._v("改期")])
                          : _vm._e(),
                        props.row.Status === 2
                          ? _c("span", [_vm._v("取消")])
                          : _vm._e(),
                        props.row.Status === 3
                          ? _c("span", [_vm._v("未報到")])
                          : _vm._e(),
                        props.row.Status === 4
                          ? _c("span", [_vm._v("已報到")])
                          : _vm._e(),
                        props.row.Status === 5
                          ? _c("span", [_vm._v("已報到")])
                          : _vm._e(),
                        props.row.Status === 6
                          ? _c("span", [_vm._v("已報到")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "window", width: "150", label: "招募窗口" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              filterable: "",
                              placeholder: "請選擇窗口",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.saveContact(
                                  $event,
                                  props.row.ArrangeGuid
                                )
                              },
                            },
                            model: {
                              value: props.row.ContactPersonGuid,
                              callback: function ($$v) {
                                _vm.$set(props.row, "ContactPersonGuid", $$v)
                              },
                              expression: "props.row.ContactPersonGuid",
                            },
                          },
                          _vm._l(_vm.contactOptions, function (item) {
                            return _c("el-option", {
                              key: item.Value,
                              attrs: { label: item.Text, value: item.Value },
                            })
                          }),
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "面談流程", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              filterable: "",
                              placeholder: "請選擇流程",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.saveFlow(
                                  $event,
                                  props.row.ArrangeGuid
                                )
                              },
                            },
                            model: {
                              value: props.row.BaseFlowGuid,
                              callback: function ($$v) {
                                _vm.$set(props.row, "BaseFlowGuid", $$v)
                              },
                              expression: "props.row.BaseFlowGuid",
                            },
                          },
                          _vm._l(_vm.flowOptions, function (item) {
                            return _c("el-option", {
                              key: item.Value,
                              attrs: {
                                label: item.Text,
                                value: item.Value,
                                disabled: !item.IsEnabled,
                              },
                            })
                          }),
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "StageName",
                  label: "目前進度",
                  width: "120",
                  sortable: "",
                  "sort-method": (a, b) => _vm.defaultSort(a, b, "StageName"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "RoomName",
                  label: "面談室",
                  width: "120",
                  sortable: "",
                  "sort-method": (a, b) => _vm.defaultSort(a, b, "RoomName"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "面談日期",
                  width: "150",
                  prop: "InvitationTime",
                  formatter: _vm.dateFormatter,
                  sortable: "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "StageStartTime",
                  label: "開始時間",
                  width: "120",
                  formatter: _vm.timeMoment,
                  sortable: "",
                  "sort-method": (a, b) =>
                    _vm.defaultSort(a, b, "StageStartTime"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "StageEndTime",
                  label: "結束時間",
                  width: "120",
                  formatter: _vm.timeMoment,
                  sortable: "",
                  "sort-method": (a, b) =>
                    _vm.defaultSort(a, b, "StageEndTime"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "StageExpectEndTime",
                  label: "預定結束時間",
                  width: "150",
                  formatter: _vm.timeMoment,
                  sortable: "",
                  "sort-method": (a, b) =>
                    _vm.defaultSort(a, b, "StageExpectEndTime"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "狀態",
                  width: "150",
                  sortable: "",
                  "sort-method": (a, b) =>
                    _vm.defaultSort(a, b, "ExpireStatus"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return _vm._l(
                        props.row.ExpireStatus,
                        function (item, index) {
                          return _c(
                            "el-tag",
                            {
                              key: index,
                              attrs: {
                                type:
                                  item === "超時" || item === "整體流程超時"
                                    ? "danger"
                                    : "warning",
                              },
                            },
                            [_vm._v(_vm._s(item))]
                          )
                        }
                      )
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._m(0),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "arrivalModal",
            tabindex: "-1",
            "data-backdrop": "static",
          },
        },
        [
          _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
            _c("div", { staticClass: "modal-content" }, [
              _vm._m(1),
              _c("div", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "p-card" }, [
                  _c("div", { staticClass: "person-info" }, [
                    _c("img", {
                      attrs: {
                        src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTEGnM5D_MDXz_E_p6vw23_wSS5G6gWD7ToOg&usqp=CAU",
                        alt: "",
                      },
                    }),
                    _c("div", { staticClass: "info" }, [
                      _c("div", { staticClass: "name" }, [
                        _vm._v(_vm._s(_vm.person.name)),
                      ]),
                      _c("div", { staticClass: "id" }, [
                        _vm._v(_vm._s(_vm.person.id)),
                      ]),
                      _c("div", { staticClass: "job" }, [
                        _vm._v(_vm._s(_vm.person.job)),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "job-info" }, [
                    _c("span", [
                      _c("div", { staticClass: "svg-wrap" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              viewBox: "0 0 512 512",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M232 120C232 106.7 242.7 96 256 96C269.3 96 280 106.7 280 120V243.2L365.3 300C376.3 307.4 379.3 322.3 371.1 333.3C364.6 344.3 349.7 347.3 338.7 339.1L242.7 275.1C236 271.5 232 264 232 255.1L232 120zM256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0zM48 256C48 370.9 141.1 464 256 464C370.9 464 464 370.9 464 256C464 141.1 370.9 48 256 48C141.1 48 48 141.1 48 256z",
                              },
                            }),
                          ]
                        ),
                      ]),
                      _c("span", [_vm._v("2022/10/31 10:00")]),
                    ]),
                    _c(
                      "span",
                      [
                        _c("div", { staticClass: "svg-wrap" }, [
                          _c(
                            "svg",
                            {
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 512 512",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z",
                                },
                              }),
                            ]
                          ),
                        ]),
                        _c("el-input", {
                          attrs: { placeholder: "請輸入未到原因" },
                          model: {
                            value: _vm.person.textarea,
                            callback: function ($$v) {
                              _vm.$set(_vm.person, "textarea", $$v)
                            },
                            expression: "person.textarea",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
              _vm._m(2),
            ]),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "rescheduleModal",
            tabindex: "-1",
            "data-backdrop": "static",
          },
        },
        [
          _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
            _c("div", { staticClass: "modal-content" }, [
              _vm._m(3),
              _c("div", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "p-card" }, [
                  _c("div", { staticClass: "person-info" }, [
                    _c("img", {
                      attrs: {
                        src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTEGnM5D_MDXz_E_p6vw23_wSS5G6gWD7ToOg&usqp=CAU",
                        alt: "",
                      },
                    }),
                    _c("div", { staticClass: "info" }, [
                      _c("div", { staticClass: "name" }, [
                        _vm._v(_vm._s(_vm.person.name)),
                      ]),
                      _c("div", { staticClass: "id" }, [
                        _vm._v(_vm._s(_vm.person.id)),
                      ]),
                      _c("div", { staticClass: "job" }, [
                        _vm._v(_vm._s(_vm.person.job)),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "job-info" }, [
                    _c("span", [
                      _c("div", { staticClass: "svg-wrap" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              viewBox: "0 0 512 512",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M232 120C232 106.7 242.7 96 256 96C269.3 96 280 106.7 280 120V243.2L365.3 300C376.3 307.4 379.3 322.3 371.1 333.3C364.6 344.3 349.7 347.3 338.7 339.1L242.7 275.1C236 271.5 232 264 232 255.1L232 120zM256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0zM48 256C48 370.9 141.1 464 256 464C370.9 464 464 370.9 464 256C464 141.1 370.9 48 256 48C141.1 48 48 141.1 48 256z",
                              },
                            }),
                          ]
                        ),
                      ]),
                      _c("span", [_vm._v("2022/10/31 10:00")]),
                    ]),
                    _c(
                      "span",
                      [
                        _c("div", { staticClass: "svg-wrap" }, [
                          _c(
                            "svg",
                            {
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 512 512",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z",
                                },
                              }),
                            ]
                          ),
                        ]),
                        _c("el-input", {
                          attrs: { placeholder: "請輸入改期原因" },
                          model: {
                            value: _vm.person.textarea,
                            callback: function ($$v) {
                              _vm.$set(_vm.person, "textarea", $$v)
                            },
                            expression: "person.textarea",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
              _vm._m(4),
            ]),
          ]),
        ]
      ),
      _c(
        "transition",
        {
          attrs: {
            name: "custom-classes-transition",
            "enter-active-class": "animated bounceInLeft",
            "leave-active-class": "animated bounceOutRight",
          },
        },
        [
          _vm.isShowDetail
            ? _c("div", { staticClass: "detail-modal" }, [
                _c("div", { staticClass: "detail-modal-inner" }, [
                  _c("div", { staticClass: "menu" }, [
                    _c("a", [
                      _c(
                        "span",
                        [
                          _c("eva-icon", {
                            attrs: { name: "person-outline", fill: "#FFF" },
                          }),
                          _vm._v(" 履歷 "),
                        ],
                        1
                      ),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "close-show-detail",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            _vm.isShowDetail = !_vm.isShowDetail
                          },
                        },
                      },
                      [
                        _c("eva-icon", {
                          attrs: {
                            name: "close-circle",
                            fill: "#FFF",
                            width: "50",
                            height: "50",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "page-wrap" },
                    [
                      _c(
                        "transition",
                        {
                          attrs: {
                            name: "custom-classes-transition",
                            "enter-active-class": "animated flipInY",
                          },
                        },
                        [
                          _c("perfect-scrollbar", { staticClass: "page" }, [
                            _c(
                              "section",
                              { staticClass: "page-inner" },
                              [
                                _c("div", { staticClass: "title" }, [
                                  _c(
                                    "div",
                                    { staticClass: "item text-center" },
                                    [_vm._v("履歷")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "item text-right" },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-outline-primary btn-sm",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.$common.downloadResumePDF(
                                                _vm.resumeDetail.ResumeType,
                                                _vm.resumeDetail.ResumeId
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" 下載 PDF ")]
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm.resumeDetail.ResumeType === "IDL"
                                  ? _c("IdlResume", {
                                      attrs: {
                                        ResumeId: _vm.resumeDetail.ResumeId,
                                        ResumeType: "IDL",
                                      },
                                    })
                                  : _vm._e(),
                                _vm.resumeDetail.ResumeType === "DL"
                                  ? _c("DlResume", {
                                      attrs: {
                                        ResumeId: _vm.resumeDetail.ResumeId,
                                        ResumeType: "DL",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: { id: "scanModal", tabindex: "-1", "data-backdrop": "static" },
      },
      [
        _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("h5", { staticClass: "modal-title" }, [_vm._v("報到")]),
            ]),
            _c("div", { staticClass: "modal-body text-center" }, [
              _c("img", {
                attrs: { src: require("@/assets/img/demo.png"), alt: "" },
              }),
            ]),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  attrs: { type: "reset", "data-dismiss": "modal" },
                },
                [_vm._v(" 關閉 ")]
              ),
            ]),
          ]),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c("h5", { staticClass: "modal-title" }, [_vm._v("未到")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-footer" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-secondary",
          attrs: { type: "reset", "data-dismiss": "modal" },
        },
        [_vm._v(" 關閉 ")]
      ),
      _c(
        "button",
        {
          staticClass: "btn btn-primary",
          attrs: { type: "reset", "data-dismiss": "modal" },
        },
        [_vm._v(" 儲存 ")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c("h5", { staticClass: "modal-title" }, [_vm._v("改期")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-footer" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-secondary",
          attrs: { type: "reset", "data-dismiss": "modal" },
        },
        [_vm._v(" 關閉 ")]
      ),
      _c(
        "button",
        {
          staticClass: "btn btn-primary",
          attrs: { type: "reset", "data-dismiss": "modal" },
        },
        [_vm._v(" 儲存 ")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }